import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentSchedule, PurchaseOrder, RelatedOrder } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0680. 支払予定一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/related_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const relatedOrders = (props: Props): Promise<RelatedOrder[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/related_orders`);
};

export const useRelatedOrders = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => relatedOrders(props),
  });
};

export const useRelatedOrdersInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'related_orders'];
};
